<mat-accordion multi>
  <mat-expansion-panel
    [expanded]="layerExpandedState"
    (opened)="onOpened()"
    (closed)="onClosed()"
    >
    <mat-expansion-panel-header>
      <mat-panel-title class="group-panel-header">{{
        group.name
      }}</mat-panel-title>
    </mat-expansion-panel-header>

    @for (layer of group.layers; track layer) {
      <atlas-layer-legend
        [layer]="layer"
        [layerExpandedState]="layersExpandedDictionary.get(layer.id)"
        (layerExpandedStateChanged)="onLayerToggle(layer.id, $event)"
        >
      </atlas-layer-legend>
    }
  </mat-expansion-panel>
</mat-accordion>
